import { render } from "./MyJumba.vue?vue&type=template&id=126a005e"
import script from "./MyJumba.vue?vue&type=script&lang=js"
export * from "./MyJumba.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__